import { RootState } from '../../../store';

export const getAdminUsers = (state: RootState) => state.admins.admins;
export const getAdminsLoading = (state: RootState) => state.admins.isLoading;
export const getAdminUsersLoadMore = (state: RootState) => state.admins.loadMore;
export const getAdminPage = (state: RootState) => state.admins.page;
export const getAdminPageSize = (state: RootState) => state.admins.pageSize;
